import { queryKeys } from "../queryKeys";
import type { Product } from "../rest/account";
import type { AccountAccessResponse } from "../rest/accountAccess";
import { getMyAccountAccess } from "../rest/accountAccess";
import useRequest, { type QueryOptions } from "./useRequest";

export const useGetAccountAccess = ({
  accountID,
  product,
  options,
}: {
  accountID?: string;
  product?: Product;
  options?: QueryOptions<AccountAccessResponse>;
}) => {
  const { data: accountAccess, ...rest } = useRequest(
    queryKeys.accounts.currentAccess(accountID || ""),
    () => getMyAccountAccess(accountID || ""),
    {
      enabled: !!accountID && product === "live",
      // Suppress the shared error toast for this query.
      meta: { showErrorToast: false },
      ...options,
    },
  );

  return {
    accountAccess,
    ...rest,
  };
};
